import React from 'react'
import { FaPhoneAlt } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'
import { LOGO } from '../../utils/Constant'
import LiveTime from './LiveTime'
import { Link, useNavigate } from 'react-router-dom'
import useFetchApi from '../../hooks/useFetchApi'

function Header() {

    const user = JSON.parse(localStorage.getItem("user_data"));
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("user_token");
        localStorage.removeItem("user_data");
        navigate("/login");
    };

    const { data: setting } = useFetchApi({
        url: 'https://orisoftpl.com/backend/api/frontend/settings',
        dataKey: 'setting'
    });

    console.log('logo :', setting);


    return (
        <>
            <header>
                <div className="header-top-line bg-[#00446d] p-1"></div>
                <div className="container mx-auto flex justify-between items-center">
                    <div className="w-1/3"></div>
                    <div className="checkStatus w-2/3 bg-[#00446d] h-[39px] before:content-[''] before:absolute before:left-1/2 before:w-1/2 before:h-[39px] before:bg-[#00446d] before:z-0">

                        <div className="liveTime float-start text-sm text-white font-semibold relative px-3 py-2 bg-[#00446d]
before:content-[''] before:absolute before:top-0 before:left-[-39px]
before:w-0 before:h-0 before:border-solid
before:border-t-[39px] before:border-t-[#00446d]
before:border-l-[39px] before:border-l-transparent">
                            <LiveTime formatOptions={{
                                weekday: 'short',
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                            }} />
                        </div>

                        {/* ✅ Show username or Login button */}
                        <div className="userLogBtn relative float-end">
                            {user ? (
                                <div className="dropdown dropdown-bottom dropdown-end">
                                    <div
                                        tabIndex={0}
                                        role="button"
                                        className="bg-warning rounded-md btn-sm text-black px-3 py-1 cursor-pointer flex items-center gap-1"
                                    >
                                        👤 {user.name}
                                    </div>
                                    <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[999] w-44 p-2 shadow mt-1">

                                        <li>
                                            <Link to="/profile" className="menu-title px-2 text-xs text-gray-500">
                                                My Profile
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                onClick={handleLogout}
                                                className="text-red-500"
                                            >
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            ) : (
                                <Link
                                    to="/login"
                                    className="bg-warning rounded-md btn-sm text-black px-3 py-1"
                                >
                                    Login
                                </Link>
                            )}
                        </div>

                    </div>
                </div>

                <div className="container mx-auto flex justify-between">
                    {/* <img src={LOGO} alt="" /> */}
                    <img
                        src={setting?.logo_url || LOGO}
                        alt="Logo"
                        className="h-20"
                    />
                    <div className="flex justify-between items-center">
                        <div className="flex justify-between items-center mr-5">
                            <MdEmail className="h-10 w-10 p-2 mr-3 border border-black rounded-full" />
                            <div>
                                <small className="text-red-500 font-bold">EMAIL SUPPORT</small>
                                <br />
                                <span>{setting?.email || "No Email"}</span>
                            </div>
                        </div>
                        <div className="flex justify-between items-center">
                            <FaPhoneAlt className="h-10 w-10 p-2 mr-3 border border-black rounded-full" />
                            <div>
                                <small className="text-red-500 font-bold">CALL SUPPORT</small>
                                <br />
                                <span>+91 {setting?.phone || "No Phone"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Navigation */}
            <div className="bg-red-800 mt-3">
                <div className="container mx-auto">
                    <div className="navbar p-0 min-h-2">
                        <div className="navbar-start">
                            <ul className="menu menu-horizontal menu-sm text-white">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/cancel-booking">Booking Price</Link></li>
                                <li><Link to="/check-availability">Check Availablity</Link></li>
                                <li><Link>Faqs</Link></li>
                            </ul>
                        </div>
                        <div className="navbar-end">
                            <Link to='/cancel-booking' className='bg-[#dc3545] px-3 py-2 text-white font-semibold text-sm mr-2'>Cancel Booking</Link>
                            <Link to='/' className='bg-green-600 px-3 py-2 text-white font-semibold text-sm'>Book Online</Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Banner */}
            <div className="Banner bg-gradient-to-br from-[#2f4ea2] to-[#00bcd4] py-16 text-white relative overflow-hidden
                after:content[''] after:absolute after:rounded-full after:bottom-[-40px] after:left-[-40px] after:w-[150px] after:h-[150px] after:bg-white/10
                before:content[''] before:absolute before:rounded-full before:top-[-50px] before:right-[-50px] before:w-[200px] before:h-[200px] before:bg-white/10">
                <div className="container mx-auto text-center">
                    <h2 className='text-4xl text-center font-bold'>Online Mandap Booking</h2>
                    <p className='text-center font-semibold mt-5'>Book Kalyan Mandap, Dharmasala, Town Hall, Guest House and Picnic Spots through a simple and secure online system.</p>
                    <Link className='btn text-black rounded-md p-2 px-5 mt-5 btn-warning text-center'>Book Online</Link>
                </div>
            </div>
        </>
    )
}

export default Header